import React, { Component } from 'react';
import { FormattedMessage  } from 'react-intl';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import SearchTable from './SearchTable'
import { SERVERS_PATH } from '../utils/constants';
import { compareStrings } from '../utils/utils';

class ServersTable extends Component {
    constructor(props) {
        super(props);

        this.layout = {
            bordered : true,
            showSizeChanger : false, 
            pagination : {pageSize: 50, showSizeChanger: false},
            size: "small",
            rowKey : record => record.id,
        };

        this.columns = [
            {
              title: <FormattedMessage id="DeviceMetersTable.name"/>,
              dataIndex: 'name',
              
              search: true,
              sorter: {
                compare: (a, b) => compareStrings(a.name, b.name),
              },
              render: (_, record) => {
                const url = SERVERS_PATH + "/" + record.id;
                return(
                <div>
                    <Link to={url}>{record.name}</Link>
                </div>
                );
              }
            },
            {
                title: <FormattedMessage id="Version"/>,
                dataIndex: 'version',
                
                search: true,
                sorter: {
                  compare: (a, b) => compareStrings(a.version, b.version),
                },
            },
            {
                title: <FormattedMessage id="LastALive"/>,
                dataIndex: 'lastAlive',
                                
                sorter: {
                  compare: (a, b) => 
                  {
                      const time_a = Date.parse(a.lastAlive);
                      const time_b = Date.parse(b.lastAlive);
                      return time_a - time_b;
                  }
                },
                search: true,
                render: (_, record) =>
                <div>
                    {record.lastAlive !== null && new Date(record.lastAlive).toLocaleString(navigator.language || navigator.userLanguage)}
                </div>
            },
            {
                title: <FormattedMessage id="LastJobDateTime"/>,
                dataIndex: 'lastJobDate',
                                
                sorter: {
                  compare: (a, b) => 
                  {
                      const time_a = Date.parse(a.lastJobDate);
                      const time_b = Date.parse(b.lastJobDate);
                      return time_a - time_b;
                  }
                },
                search: true,
                render: (_, record) =>
                <div>
                    {record.lastJobDate !== null && new Date(record.lastJobDate).toLocaleString(navigator.language || navigator.userLanguage)}
                </div>
            },
            {
                title: <FormattedMessage id="URL"/>,
                dataIndex: 'serverUrl',
                                
                sorter: {
                    compare: (a, b) => compareStrings(a.serverUrl, b.serverUrl)
                },
                search: true,
                render: (_, record) =>
                <div>
                    <a href={'http://' + record.serverUrl} target='_blank' rel="noopener noreferrer">{record.serverUrl}</a> 
                </div>
            },
        ];   
      }

    onSelectChange(selectedRowKeys) {
        if (this.props.onSelectChange !== undefined)
        {
            this.props.onSelectChange(selectedRowKeys);
        }
    }

     render() {
    
          return (
            <div className = "report-table">
                <SearchTable
                    layout = {this.layout}
                    type = {undefined}
                    columns={this.columns} 
                    dataSource={this.props.data} 
                />
            </div>
          );
        }
    } 
       
    ServersTable.propTypes = {
    data: PropTypes.array.isRequired,
    };

export default ServersTable;
